<div class="contenListFlights">
  <ng-container *ngIf="
      this.stateService.flightSelectedState.solutions &&
      this.stateService.flightSelectedState.solutions.length > 0
    ">
    <div class="card-content"
      *ngFor="let solution of this.stateService.flightSelectedState.solutions | slice: lowValue:highValue; let i = index">
      <div class="associations" [ngClass]="{ 'associations-oneWay': oneWay }">
        <div *ngFor="let association of solution.data.associations; let j = index" class="association-container">
          <div class="left">
            <div class="rowh">
              <div class="cardContentContainer">
                <div *ngFor="let journey of association.journey_references; let w = index" style="display: flex;align-items: center;">
                    <mat-checkbox  style="padding: 1rem;"
                        (change)="checkAssociationJourney(association, journey)"
                        [checked]="isAssociationJourneyChecked(association, journey, w)"
                      >
                      </mat-checkbox>
                    <input type="radio" [id]="journey" [checked]="association.journeyChecked === journey"
                      name="checkedReturn" class="custom-control-input" (click)="checkAssociationJourney(association, journey)" />
                  <div class="journey">
                    <div class="airline-container">
                      <img class="airlineLogo" [src]="
                          getLogo(
                            getSegment(journey).object
                              .marketing_company
                          )
                        " alt="logo" width="72px" />
                      <span class="flight-number">
                        {{
                        getSegment(journey).object
                        .marketing_company
                        }}
                        {{
                        getSegment(journey).object
                        .transport_number
                        }}
                      </span>
                      <span class="cabin-class">
                        {{ association.segment_references[w].object?.cabin?.short_name }}
                      </span>
                    </div>

                    <div class="baggage-hover" *ngIf="getCabinBaggageInfo(association) as cab">
                      <ng-container *ngIf="getCheckedBaggageInfo(association) as chk">
                        <div class="baggage-row">
                          <div class="baggage-item">
                            <div class="icon-wrapper" [ngClass]="{
                                'included': cab.included,
                                'not-included': !cab.included
                              }">
                              <img src="assets/img/svg/bag.svg" alt="cabin" />
                              <span class="slash" *ngIf="!cab.included"></span>
                            </div>
                          </div>

                          <div class="baggage-item">
                            <div class="icon-wrapper" [ngClass]="{
                                'included': chk.included && chk.known,
                                'not-included': !chk.included && chk.known
                              }">
                              <img src="assets/img/svg/luggage.svg" alt="checked" />
                              <span class="badge-top" *ngIf="chk.included && chk.isUnits && chk.topText">
                                {{ chk.topText }}
                              </span>
                              <span class="badge-bottom" *ngIf="chk.included && chk.bottomText">
                                {{ chk.bottomText }}
                              </span>
                              <span class="slash" *ngIf="chk.known && !chk.included"></span>
                            </div>
                          </div>
                        </div>

                        <div class="baggage-popover">
                          <div class="pop-section">
                            <img class="pop-icon" src="assets/img/svg/bag.svg" alt="cabin"
                              [class.muted]="!cab.included" />
                            <div class="pop-body">
                              <div class="pop-title" [class.included]="cab.included">
                                {{ 'flight.result-flight.cabin-luggage' | translate }}
                              </div>
                              <div class="pop-line"></div>
                              <div class="pop-text" *ngIf="cab.included; else cabinUnknownOrNo">
                                <span class="pop-strong">{{ 'flight.result-flight.included' | translate }}</span>
                                {{ 'flight.result-flight.in-rate' | translate }}
                              </div>
                              <ng-template #cabinUnknownOrNo>
                                <div class="pop-text pop-text--muted">
                                  {{ 'flight.result-flight.no-info' | translate }}
                                </div>
                              </ng-template>
                            </div>
                          </div>

                          <div class="pop-section" style="border-bottom: none;">
                            <img class="pop-icon" src="assets/img/svg/luggage.svg" alt="checked"
                              [class.muted]="!chk.included" />
                            <div class="pop-body">
                              <div class="pop-title" [class.included]="chk.included">
                                {{ 'flight.result-flight.baggage-in-hold' | translate }}
                              </div>
                              <div class="pop-line"></div>
                              <div class="pop-text" *ngIf="chk.included; else notIncluded">
                                <span class="pop-strong">{{ 'flight.result-flight.included' | translate }}</span>
                                {{ 'flight.result-flight.in-rate' | translate }}

                                <div *ngIf="chk.isUnits && chk.topText">
                                  <span class="pop-strong">{{ 'flight.result-flight.parts' | translate }}</span>:
                                  <span>{{ chk.topText }}</span>
                                </div>

                                <div *ngIf="chk.bottomText && !chk.isUnits">
                                  <span class="pop-strong">{{ 'flight.result-flight.weight' | translate }}</span>:
                                  <span>{{ chk.bottomText }}</span>
                                </div>
                              </div>

                              <ng-template #notIncluded>
                                <div class="pop-text pop-text--muted">
                                  <span class="pop-inline">
                                    <span class="pop-strong">{{ 'flight.result-flight.not-included' | translate
                                      }}</span>
                                    &nbsp;{{ 'flight.result-flight.in-rate' | translate }}
                                  </span>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                          <span class="pop-arrow"></span>
                        </div>
                      </ng-container>
                    </div>

                    <div class="origin">
                      <span class="colored">{{
                        getSegment(journey).object.departure
                        }}</span>
                      <span class="bold">{{
                        getTime(
                        getSegment(journey).object.departure_date
                        )
                        }}</span>
                      <span>{{
                        formatDate(
                        getSegment(journey).object.departure_date
                        )
                        }}</span>
                    </div>
                    <div class="iconFlight">
                      <img src="assets/img/svg/flight-takeoff.svg" alt="" />
                    </div>
                    <div class="linewrap">
                      <p class="stops clickable-text" (click)="toggleStops(i)"
                        *ngIf="getStops(journey).length > 0; else elseBlock">
                        {{ getStops(journey).length }}
                        {{
                        (getStops(journey).length > 1
                        ? "flight.detail-flight.stops"
                        : "flight.detail-flight.stop"
                        ) | translate
                        }}
                        {{
                        getStops(journey).join(", ")
                        }}
                      </p>
                      <ng-template #elseBlock>
                        <p class="stops">{{ "flight.result-flight.direct-flight" | translate }}</p>
                      </ng-template>
                      <div class="linesingle"></div>
                      <span class="duration">
                        {{
                        calcTotalSegmentTime(journey)
                        }}
                      </span>
                    </div>
                    <div class="iconFlight">
                      <img src="assets/img/svg/flight-landing.svg" alt="" />
                    </div>
                    <div class="destination">
                      <span class="colored">{{
                        getLastSegment(journey).object
                        .arrival
                        }}</span>
                      <span class="bold">{{
                        getTime(
                        getLastSegment(journey)
                        .object.arrival_date
                        )
                        }}
                      </span>
                      <span>{{
                        formatDate(
                        getLastSegment(journey).object
                        .arrival_date
                        )
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- precio y boton-->
        <div class="colPrice">
          <div>
            <div>
              <h6>
                {{
                (oneWay
                ? "flight.result-flight.oneway-price"
                : "flight.result-flight.return-price"
                ) | translate
                }}
              </h6>
              <div style="margin: 0.5rem 0 !important;" *ngIf="needsAuthorization(solution)">
                <span class="authorization-required">
                  {{ "authorization.required-auth" | translate }}
                </span>
              </div>
              <h6 class="my-auto price">
                {{
                (!company?.showCommissions || isEmployee)
                ? solution.total_price.total
                : (solution.total_price.base + solution.total_price.total_taxes)
                | price }}€
              </h6>
            </div>
            <div id="right-button-container">
              <button (click)="getMultifamily(solution, w)" class="custom-btn">
                {{ (needsAuthorization(solution) && isUser)
                ? ("flight.form-flight.request-flight" | translate)
                : ("flight.result-flight.book-flight" | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="layover-panel" *ngIf="openedStopsIndex.has(i)">
        <div class="layout-panel-custom">
          <div class="layover-item" *ngFor="let association of solution.data.associations; let j = index">
            <div class="layover-header" *ngIf="getLayoverInfo(journey).length > 0">
              <strong>
                {{
                oneWay
                ? ("flight.detail-flight.scale-details-outbound" | translate)
                : (j === 0
                ? ("flight.detail-flight.scale-details-outbound" | translate)
                : ("flight.detail-flight.scale-details-return" | translate))
                }}
              </strong>
            </div>
            <ng-container *ngFor="let layover of getLayoverInfo(journey)">
              <div class="layover-card">
                <div class="layover-airports-row">
                  <div class="layover-airports">
                    <span class="airport-code">{{ layover.from }}</span>
                    <span class="layover-arrow">→</span>
                    <span class="airport-code">{{ layover.to }}</span>
                  </div>
                  <div class="layover-duration-inline">
                    {{ "flight.detail-flight.layover-duration" | translate }}:
                    <strong>{{ layover.duration }}</strong>
                  </div>
                </div>
                <div class="layover-info-row">
                  <div class="layover-times-visual">
                    <div class="layover-time-block">
                      <img src="assets/img/svg/flight-landing.svg" alt="arrival" class="layover-icon" />
                      <div class="layover-time-info">
                        <div class="layover-label">
                          {{ "flight.detail-flight.arrival-time-to" | translate }} {{ layover.from }}
                        </div>
                        <div class="layover-time">{{ layover.arrivalTime }}</div>
                      </div>
                    </div>
                    <div class="layover-time-block">
                      <img src="assets/img/svg/flight-takeoff.svg" alt="departure" class="layover-icon" />
                      <div class="layover-time-info">
                        <div class="layover-label">
                          {{ "flight.detail-flight.departure-time-to" | translate }} {{ layover.to }}
                        </div>
                        <div class="layover-time">{{ layover.departureTime }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="layover-logo">
                    <div class="logo-wrapper">
                      <img [src]="getLogo(layover.company)" [alt]="layover.company" />
                      <div class="flight-number">{{ layover.flightNumber }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator class="d-flex justify-content-center" [length]="getResultLength()" [pageSize]="10"
      (page)="getPaginatorData($event)" [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons [hidePageSize]="true"
      style="border-radius: 15px">
    </mat-paginator>
  </ng-container>
</div>